import { checkboxBaseStyle } from '../checkbox-base';
import {
    GridCheckboxesVariants
} from '@containers/activity-router/data-grid-container/grid/grid-checkbox/grid-checkbox.types';

export const GridCheckbox = {
    [GridCheckboxesVariants.activityCheckbox]: {
        control: {
            ...checkboxBaseStyle,
            w: '24px',
            h: '24px',
            svg: { width: '16px' }
        }
    },
    [GridCheckboxesVariants.studentCheckbox]: {
        control: {
            ...checkboxBaseStyle,
            w: '32px',
            h: '32px'
        }
    },
    [GridCheckboxesVariants.topicCheckbox]: {
        borderRight: '1px solid',
        borderColor: 'neutral.200',
        control: {
            ...checkboxBaseStyle,
            w: '32px',
            h: '32px',
            svg: { width: '20px' }
        }
    },
    [GridCheckboxesVariants.assignedCheckbox]: {
        control: {
            ...checkboxBaseStyle,
            w: '24px',
            h: '24px',
            svg: { width: '16px' }
        }
    },
    [GridCheckboxesVariants.dokCheckbox]: {
        control: {
            ...checkboxBaseStyle,
            borderRadius: '4px',
            borderWidth: '1px',
            borderColor: 'primary.200',
            w: '20px',
            h: '20px',

            svg: { width: '12px' }
        },
        input: {
            width: '20px',
            height: '20px'
        }
    },
    [GridCheckboxesVariants.cardViewBodyCheckbox]: {
        control: {
            ...checkboxBaseStyle,
            borderRadius: '4px',
            borderWidth: '1px',
            borderColor: 'primary.200',
            w: '20px',
            h: '20px',

            svg: { width: '12px' },

            _disabled: {
                borderColor: 'neutral.50',
                background: 'white.0',
                pointerEvents: 'none'
            },

            _hover: {
                borderColor: 'primary.400'
            }
        },
        input: {
            width: '20px',
            height: '20px'
        }
    },
    [GridCheckboxesVariants.circleCheckbox]: {
        control: {
            ...checkboxBaseStyle,
            w: '32px',
            h: '32px',
            borderRadius: '48px',
            svg: { width: '20px' }
        },
        input: {
            width: '14px',
            height: '14px'
        }
    },
    [GridCheckboxesVariants.overviewCheckbox]: {
        control: {
            ...checkboxBaseStyle,
            border: '1px solid',
            borderColor: 'primary.300',
            w: '24px',
            h: '24px',
            svg: { width: '16px' },
            _hover: {
                borderColor: 'primary.500'
            }
        },
        input: {
            width: '14px',
            height: '14px'
        }
    }
};
